import axios from 'axios'

const state = () => ({
  news: []
})

const getters = {
  news(state) {
    return state.news
  }
}

const mutations = {
  SET_NEWS(state, payload){
    state.news = payload
  },
  DELETE_NEWS(state, id){
    state.news.results = state.news.results.filter((x) => x.id != id);
  },
  ADD_NEWS(state, data){
    state.news.results.push(data);
  },
  EDIT_NEWS(state, data){
    state.news.results = state.news.results.map((vm)=>{
      if(vm.id == data.id){ return data}
      else{ return vm }
    });
  }
}

const actions = {
  getNews({commit}, page){
    axios.get(`https://api.geomalaka.uz/api/main/news/?page=${page ? page : 1}`)
    .then((res)=>{
      commit("SET_NEWS", res.data)
      // this._vm.$toast('Successful', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  getNewsAll({commit}){
    axios.get(`https://api.geomalaka.uz/api/main/all-news/`)
      .then((res)=>{
        commit("SET_NEWS", res.data)
        // this._vm.$toast('Successful', {type: 'success'})
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  deleteNews({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/main/news/${id}/`)
    .then((res)=>{
      commit("DELETE_NEWS", id)
      this._vm.$toast('Deleted', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  addNews({commit}, payload){
    axios.post('https://api.geomalaka.uz/api/main/news/', payload)
    .then((res)=>{
      commit("ADD_NEWS", res.data)
      this._vm.$toast(res.statusText, {type: 'success'});
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  editNews({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/main/news/${payload.id}/`, payload.data)
    .then((res)=>{
      commit("EDIT_NEWS", res.data)
      this._vm.$toast('Successful', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
